import { APP_ENV, USE_FIREBASE_EMULATOR } from '@env';

export type AppEnv = 'local' | 'staging' | 'production';

const raw = String(APP_ENV ?? 'local').toLowerCase();
export const env: AppEnv =
  raw === 'production' ? 'production' : raw === 'staging' ? 'staging' : 'local';

export const useEmulator = String(USE_FIREBASE_EMULATOR ?? '').toLowerCase() === 'true';

export const ENV_LABELS: Record<AppEnv, { label: string; color: string; bgColor: string }> = {
  local: { label: 'LOCAL · EMULADOR', color: '#FFFFFF', bgColor: '#0EA5E9' },
  staging: { label: 'STAGING · PRUEBAS', color: '#0F172A', bgColor: '#F59E0B' },
  production: { label: 'PRODUCCIÓN', color: '#FFFFFF', bgColor: '#0F9D58' },
};

export const isProduction = env === 'production';
export const isLocal = env === 'local';
export const isStaging = env === 'staging';
